var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"outlined":"","hide-details":"auto","error":!!_vm.errors.length,"error-messages":_vm.errors,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"rows":_vm.rows},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }